import {
  MEDIA_EXTENSIONS,
  MEDIA_MIMES,
  toAcceptList,
} from '@/hooks/useUpload/fileTypeLists'

// Feedback deliberately stays on the image/video/PDF set — it is not one of the
// incident surfaces widened by ENG-30297.
export const ALLOWED_EXTENSIONS = toAcceptList(MEDIA_EXTENSIONS)
export const ALLOWED_MIME_TYPES = MEDIA_MIMES

export const MAX_FILENAME_LENGTH = 255
export const MAX_FILE_SIZE = 524288000 // 500 MB
